<template>
    <div id="app">
        <default-layout/>
    </div>
</template>

<script>
import DefaultLayout from "@/layouts/default";
export default {
    name: "app",
    components: { DefaultLayout },

    computed: {
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        }
    },
    created() {
        // Nothing
    }
};
</script>

